import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Quote/';

const getQuotes = async () => axiosInstance.get(`${ENDPOINTORIGIN}GetQuotes`, constants.REQUIRE_INTERCEPTORS);

const getQuoteById = async (quoteId) => axiosInstance.get(`${ENDPOINTORIGIN}GetQuoteById?quoteId=${quoteId}`, constants.REQUIRE_INTERCEPTORS);

const createQuote = async (quote) => axiosInstance.post(`${ENDPOINTORIGIN}CreateQuote`, quote, constants.REQUIRE_INTERCEPTORS);

const updateQuote = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateQuote`, model, constants.REQUIRE_INTERCEPTORS);

const deleteQuote = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteQuote?id=${id}`, constants.REQUIRE_INTERCEPTORS);

const completeQuote = async (id) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateQuote?id=${id}`, {}, constants.REQUIRE_INTERCEPTORS);

const updateCostAndComment = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateCostAndComment`, model, constants.REQUIRE_INTERCEPTORS);

const emailQuote = async (model) => axiosInstance.post(`${ENDPOINTORIGIN}EmailQuote`, model, constants.REQUIRE_INTERCEPTORS);

const approveQuote = async (id) => axiosInstance.put(`${ENDPOINTORIGIN}ApproveQuote?quoteId=${id}`, {}, constants.REQUIRE_INTERCEPTORS);

const rejectQuote = async (id, rejectionReason) => axiosInstance.put(`${ENDPOINTORIGIN}RejectQuote?rejectionReason=${rejectionReason}&quoteId=${id}`, {}, constants.REQUIRE_INTERCEPTORS);

export {
  getQuotes,
  getQuoteById,
  createQuote,
  updateQuote,
  deleteQuote,
  completeQuote,
  updateCostAndComment,
  emailQuote,
  approveQuote,
  rejectQuote
};